import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { useGetUserDetailsQuery } from '@/features/user/userApi';

/**
 * Resolves audit user filters — empty selection defaults to the logged-in user
 * (same behaviour as useInstantSearchOwnerFilters for deal/renewal tables).
 */
export const useAuditUserFilters = () => {
	const filters = useSelector((state) => state.auditTablePrefs);
	const account = useSelector((state) => state.msalAccount.account);
	const email = account?.username;

	const { data: userDetails } = useGetUserDetailsQuery({ email }, { skip: !email });
	const userId = userDetails?.userId;
	const canViewGroup = userDetails?.canViewGroup;

	const storedUserIds = filters.userIds ?? [];

	const userIds = useMemo(() => {
		if (!userId) return [];

		let data = (!canViewGroup || !storedUserIds.length ? [userId] : storedUserIds)
			.flat()
			.filter((id) => id != null);

		if (data.length === 0) {
			data = [userId];
		}

		return data;
	}, [canViewGroup, storedUserIds, userId]);

	return {
		userId,
		canViewGroup,
		storedUserIds,
		userIds,
	};
};
